import { Tooltip } from 'bootstrap';

export default function initTooltip() {
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');

  tooltips.forEach((el) => {
    new Tooltip(el);
  });
}
